<template>
  <el-drawer
    custom-class="share-drawer"
    title=""
    :visible.sync="drawer"
    direction="btt"
    :before-close="handleClose"
  >
    <div class="drawer-cont">
      <template v-if="!selectShare.type">
        <!-- tips -->
        <p v-if="shareInfo.canJoinNum" class="title-tips">
          再邀
          <span style="color: #f03349">{{ shareInfo.canJoinNum }}</span>
          人,人满后可开通课程
        </p>
        <ul class="share-list">
          <li
            @click="handleShare(item)"
            class="share-item"
            v-for="item in shareList"
            :key="item.type"
          >
            <img :src="item.image" alt="" />
            <span>{{ item.text }}</span>
          </li>
        </ul>
      </template>
      <div class="share-content" v-else>
        <div class="qrcode-box">
          <create-qr-code
            v-if="shareInfo.shareUrl"
            ref="qrCode"
            :url="shareInfo.shareUrl"
            :logo-url="logoUrl"
            :canvas-width="140"
            :canvas-height="140"
            @create-qr-code="getQrCode"
          />
        </div>
        <div class="tips">{{ selectShare.content }}</div>
      </div>
      <button @click="handleClose" class="close-btn">取消</button>
    </div>
  </el-drawer>
</template>

<script>
import { copyPageUrl } from "@saas/components/src/utils/utils";
import shareSdk from "@saas/components/src/utils/share";
import CreateQrCode from "@saas/components/src/components/CreateQrCode";
export default {
  props: {},
  data: function () {
    return {
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      drawer: false,
      shareList: [
        {
          type: "wechat",
          image: require("../../../assets/images/share-drawer/wx.png"),
          text: "微信",
        },
        // {
        //   type: "circle",
        //   image: require("../../../assets/images/share-drawer/wx-circle.png"),
        //   text: "朋友圈",
        // },
        // {
        //   type: "QQ",
        //   image: require("../../../assets/images/share-drawer/qq.png"),
        //   text: "QQ好友",
        // },
        // {
        //   type: "space",
        //   image: require("../../../assets/images/share-drawer/qq-space.png"),
        //   text: "QQ空间",
        // },
        {
          type: "weibo",
          image: require("../../../assets/images/share-drawer/weibo.png"),
          text: "微博",
        },
        // {
        //   type: "xhs",
        //   image: require("../../../assets/images/share-drawer/xhs.png"),
        //   text: "小红书",
        // },
        {
          type: "link",
          image: require("../../../assets/images/share-drawer/link.png"),
          text: "复制链接",
        },
      ],
      selectShare: {},
      shareInfo: {},
    };
  },
  methods: {
    getQrCode(url) {},
    handleShare(item) {
      let type = item.type;
      let { shareUrl, title, pic, linkShowTitle, copyTostMsg } = this.shareInfo;
      if (type === "wechat") {
        this.selectShare = {
          type: "wechat",
          title: "微信",
          content: "保存二维码，将课程分享给微信好友吧",
        };
      } else if (type === "weibo") {
        shareSdk("weibo", {
          url: shareUrl, // 分享地址
          title, // 分享标题
          pic,
        });
        this.handleClose();
      } else if (type === "link") {
        let cont = shareUrl;
        if (linkShowTitle) {
          cont = title + cont;
        }
        copyPageUrl(copyTostMsg || "", cont);
        this.handleClose();
      }
    },
    handleClose() {
      this.drawer = false;
      this.selectShare = {};
      this.shareInfo = {};
    },
    openDrawer(params) {
      this.shareInfo = params;
      this.drawer = true;
    },
  },
  components: {
    CreateQrCode,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .share-drawer {
  border-radius: 0.43rem 0.43rem 0rem 0rem;
  min-height: 5.35rem;
  height: auto !important;
  #el-drawer__title {
    display: none;
  }
}
.drawer-cont {
  min-height: 5.35rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 0.37rem;
}
.share-drawer {
  .share-list {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 0.49rem auto;
  }
  .share-item {
    margin: 0 0.425rem 0.44rem;
    img {
      width: 1.33rem;
      height: 1.33rem;
      margin-bottom: 0.21rem;
    }
    span {
      display: block;
      font-size: 0.32rem;
      color: #0d1400;
      line-height: 0.44rem;
      text-align: center;
    }
  }
  .close-btn {
    width: 9.25rem;
    height: 1.07rem;
    background: #f2f3f5;
    border-radius: 0.21rem;
    margin: 0 auto;
    font-size: 0.37rem;
    color: #0d1400;
    line-height: 0.53rem;
  }
}
.share-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.1rem;
  margin-bottom: 0.55rem;
  .qrcode-box {
    // width: 3.73rem;
    // height: 3.73rem;
    // canvas {
    //   width: 100%;
    //   height: 100%;
    // }
  }
  .tips {
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 0.6rem;
    margin-top: 0.1rem;
  }
}
.title-tips {
  font-weight: 600;
  font-size: 0.56rem;
  color: #222426;
  line-height: 0.79rem;
  margin-top: 0.27rem;
  margin-bottom: 0.7rem;
}
</style>
